import {
    apiRequest,
    sampleCreate
} from "../../../../services/adapters/base"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", sampleCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository